module.exports = __webpack_public_path__ + "img/成功.f9c1c96d.png";